import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const Services = () => {
    const [servicesData, setServicesData] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("https://www.wltz.space/php/src/api/zarzadzanie.php", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ action: "get_management" }),
                });
                const data = await response.json();
                setServicesData(data.management.SERVICES || {});
            } catch (error) {
                setError("Error fetching services data");
                console.error("Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
        AOS.init({ duration: 1000, once: true });
    }, []);

    if (loading) {
        return <div className="text-center py-20">Loading...</div>;
    }

    if (error) {
        return <div className="text-center py-20 text-red-500">{error}</div>;
    }

    return (
        <div id="services" className="max-w-6xl mx-auto py-20">
            {/* --- UJEDNOLICONA SEKCJA TYTUŁOWA (jak w Contact) --- */}
            <div className="text-center mb-16" data-aos="fade-up">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mt-2 uppercase">
                    {servicesData.subtitle || "Nasze Usługi"}
                </h2>
                <div className="w-96 h-0.5 bg-[#a07c5c] mx-auto my-4"></div>
                <p className="text-gray-500 mt-4 max-w-2xl mx-auto">
                    {servicesData.description || "Opis naszych usług, który pojawi się, gdy dane nie zostaną załadowane."}
                </p>
            </div>

            {/* --- UJEDNOLICONA STRUKTURA TREŚCI (jak w Contact) --- */}
            <section className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-start">

                {/* Lewa kolumna: Obrazy */}
                <div className="flex items-center justify-center -mx-4 lg:pl-8" data-aos="fade-right">
                    <div className="flex flex-col items-end px-3">
                        <img
                            className="object-cover mb-6 rounded shadow-lg h-28 sm:h-48 xl:h-56 w-28 sm:w-48 xl:w-56"
                            src={servicesData.image_1}
                            alt="Service detail 1"
                        />
                        <img
                            className="object-cover w-20 h-20 rounded shadow-md sm:h-32 xl:h-40 sm:w-32 xl:w-40"
                            src={servicesData.image_2}
                            alt="Service detail 2"
                        />
                    </div>
                    <div className="px-3">
                        <img
                            className="object-cover w-40 h-40 rounded shadow-lg sm:h-64 xl:h-80 sm:w-64 xl:w-80"
                            src={servicesData.image_3}
                            alt="Service detail 3"
                        />
                    </div>
                </div>

                {/* Prawa kolumna: Tekst i lista usług */}
                <div className="flex flex-col justify-center" data-aos="fade-left">
                    <div className="max-w-2xl">
                        <h3 className="max-w-2xl mb-6 font-sans text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl sm:leading-none">
                            {servicesData.main_title}
                        </h3>
                        <p className="text-base text-gray-700 md:text-lg">
                            {servicesData.main_description}
                        </p>
                        <ul className="list-disc ml-6 my-4 space-y-2 text-gray-700 font-medium">
                            {servicesData.service_1 && <li>{servicesData.service_1}</li>}
                            {servicesData.service_2 && <li>{servicesData.service_2}</li>}
                            {servicesData.service_3 && <li>{servicesData.service_3}</li>}
                            {servicesData.service_4 && <li>{servicesData.service_4}</li>}
                            {servicesData.service_5 && <li>{servicesData.service_5}</li>}
                        </ul>
                    </div>
                </div>

            </section>
        </div>
    );
};

export default Services;